import React from 'react'
import {t} from '../lib/localize'

export function NPC({name}) {
  return <div className='character npc'>{t('characters.cynthia.avatar')}</div>
}

